import { DataUpdateAPI } from '../../../api/genericLayout/DataUpdateAPI';

export class DataUpdateCommand {
    constructor(appName) {
        this.dataUpdateApi = new DataUpdateAPI(appName);
    }

    list(edition, successCallback, errorCallback) {
        const apiResult = this.dataUpdateApi.list(edition);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as atualizações de dados");
            }
        });
    }
}
